import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import translationEN from './Translations/en.json';
import translationDE from './Translations/de.json';
import storage from './store/storage';

const resources = {
  en: {
    translation: translationEN,
  },
  de: {
    translation: translationDE,
  },
};

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: storage.load({ key: 'appLanguage' }) || 'en',
    useSuspense: false,
    debug: false,

    interpolation: {
      escapeValue: false,
    },
  });

export const translate = (scope: string, path: string, params?: Object) => i18n.t(`${scope}.${path}`, params);

export const getTranslateByScope = (scope: string) => (
  key: string,
  params?: Object,
) => translate(scope, key, params);

export const changeAppLanguage = (language) => {
  storage.save({ key: 'appLanguage', value: language });
  i18n.changeLanguage(language);
};

export const currentLanguage = () => i18n.language;

export default i18n;
